import CRM01_001INS from "@/views/MICRM/CRM01_001INS.vue";
import CRM01_008INS from "@/views/MICRM/CRM01_008INS.vue";
import CRM01_009RPT from "@/views/MICRM/CRM01_009RPT.vue";
import CRM01_010RPT from "@/views/MICRM/CRM01_010RPT.vue";
import CRM01_012INS from "@/views/MICRM/CRM01_012INS.vue";
import CRM01_013INS from "@/views/MICRM/CRM01_013INS.vue";
import CRM01_050INS from "@/views/MICRM/CRM01_050INS.vue";
import CRM02_002RPT from "@/views/MICRM/CRM02_002RPT.vue";
import CRM03_002INS from "@/views/MICRM/CRM03_002INS.vue";
import CRM03_004INS from "@/views/MICRM/CRM03_004INS.vue";
import CRM03_008RPT from "@/views/MICRM/CRM03_008RPT.vue";
import CRM03_009RPT from "@/views/MICRM/CRM03_009RPT.vue";
import CRM03_010RPT from "@/views/MICRM/CRM03_010RPT.vue";
import CRM03_011RPT from "@/views/MICRM/CRM03_011RPT.vue";
import CRM03_012RPT from "@/views/MICRM/CRM03_012RPT.vue";
import CRM03_034INS from "@/views/MICRM/CRM03_034INS.vue";
import CRM05_003RPT from "@/views/MICRM/CRM05_003RPT.vue";
import CRM05_004RPT from "@/views/MICRM/CRM05_004RPT.vue";
import CRM05_007INS from "@/views/MICRM/CRM05_007INS.vue";
import CRM05_008INS from "@/views/MICRM/CRM05_008INS.vue";
import CRM10_001INS from "@/views/MICRM/CRM10_001INS.vue";
import CRM10_004RPT from "@/views/MICRM/CRM10_004RPT.vue";
import CRM10_007INS_shy from "@/views/MICRM/CRM10_007INS_shy.vue";
import CRM10_019INS from "@/views/MICRM/CRM10_019INS.vue";
import CRM10_020INS from "@/views/MICRM/CRM10_020INS.vue";
import CRM10_021RPT from "@/views/MICRM/CRM10_021RPT.vue";
import CRM10_022RPT from "@/views/MICRM/CRM10_022RPT.vue";
import CRM10_023RPT from "@/views/MICRM/CRM10_023RPT.vue";
import CRM10_024RPT from "@/views/MICRM/CRM10_024RPT.vue";
import CRM10_025RPT from "@/views/MICRM/CRM10_025RPT.vue";
import CRM11_006RPT from "@/views/MICRM/CRM11_006RPT.vue";
import CRM11_007RPT from "@/views/MICRM/CRM11_007RPT.vue";
import CRM11_013RPT from "@/views/MICRM/CRM11_013RPT.vue";
import CRM20_003INS from "@/views/MICRM/CRM20_003INS.vue";
import CRM20_005RPT from "@/views/MICRM/CRM20_005RPT.vue";
import CRM20_006RPT from "@/views/MICRM/CRM20_006RPT.vue";
import CRM20_007RPT from "@/views/MICRM/CRM20_007RPT.vue";
import CRM20_009RPT from "@/views/MICRM/CRM20_009RPT.vue";
import CRM20_010RPT from "@/views/MICRM/CRM20_010RPT.vue";
import CRM20_011INS from "@/views/MICRM/CRM20_011INS.vue";
import CRM20_012INS from "@/views/MICRM/CRM20_012INS.vue";
import CRM20_013RPT from "@/views/MICRM/CRM20_013RPT.vue";
import CRM21_004INS from "@/views/MICRM/CRM21_004INS.vue";
import CRM22_001INS from "@/views/MICRM/CRM22_001INS.vue";
import CRM22_002INS from "@/views/MICRM/CRM22_002INS.vue";
import CRM40_056RPT from "@/views/MICRM/CRM40_056RPT.vue";
import CRM40_057RPT from "@/views/MICRM/CRM40_057RPT.vue";
import CRM60_004INS from "@/views/MICRM/CRM60_004INS.vue";
import CRM60_006INS from "@/views/MICRM/CRM60_006INS.vue";
import CRM60_007INS from "@/views/MICRM/CRM60_007INS.vue";
import CRM60_008INS from "@/views/MICRM/CRM60_008INS.vue";
import CRM60_009INS from "@/views/MICRM/CRM60_009INS.vue";
import CRM65_001RPT from "@/views/MICRM/CRM65_001RPT.vue";
import CRM65_002RPT from "@/views/MICRM/CRM65_002RPT.vue";
import CRM65_004RPT from "@/views/MICRM/CRM65_004RPT.vue";
import CRM65_005RPT from "@/views/MICRM/CRM65_005RPT.vue";
import CRM21_002INS from "../views/MICRM/CRM21_002INS.vue";
import CRM60_010INS from "@/views/MICRM/CRM60_010INS.vue";
import CRM03_019RPT from "@/views/MICRM/CRM03_019RPT.vue";

export default function micrmRouter() {
  return [
    {
      path: "CRM20_005RPT.xml",
      component: CRM20_005RPT,
    },
    {
      path: "CRM20_006RPT.xml",
      component: CRM20_006RPT,
    },
    {
      path: "CRM20_007RPT.xml",
      component: CRM20_007RPT,
    },
    {
      path: "CRM20_009RPT.xml",
      component: CRM20_009RPT,
    },
    {
      path: "CRM20_010RPT.xml",
      component: CRM20_010RPT,
    },
    {
      path: "CRM20_012INS.xml",
      component: CRM20_012INS,
    },
    {
      path: "CRM20_013RPT.xml",
      component: CRM20_013RPT,
    },
    {
      path: "CRM10_021RPT.xml",
      component: CRM10_021RPT,
    },
    {
      path: "CRM10_022RPT.xml",
      component: CRM10_022RPT,
    },
    {
      path: "CRM10_023RPT.xml",
      component: CRM10_023RPT,
    },
    {
      path: "CRM10_024RPT.xml",
      component: CRM10_024RPT,
    },
    {
      path: "CRM10_025RPT.xml",
      component: CRM10_025RPT,
    },
    {
      path: "CRM10_007INS_shy.xml",
      component: CRM10_007INS_shy,
    },
    {
      path: "CRM10_019INS.xml",
      component: CRM10_019INS,
    },
    {
      path: "CRM10_020INS.xml",
      component: CRM10_020INS,
    },
    {
      path: "CRM02_002RPT.xml",
      component: CRM02_002RPT,
    },
    {
      path: "CRM03_002INS.xml",
      component: CRM03_002INS,
    },
    {
      path: "CRM03_012RPT.xml",
      component: CRM03_012RPT,
    },
    {
      path: "CRM03_011RPT.xml",
      component: CRM03_011RPT,
    },
    {
      path: "CRM03_004INS.xml",
      component: CRM03_004INS,
    },
    {
      path: "CRM03_008RPT.xml",
      component: CRM03_008RPT,
    },
    {
      path: "CRM03_009RPT.xml",
      component: CRM03_009RPT,
    },
    {
      path: "CRM03_010RPT.xml",
      component: CRM03_010RPT,
    },
    {
      path: "CRM03_034INS.xml",
      component: CRM03_034INS,
    },
    {
      path: "CRM01_001INS.xml",
      component: CRM01_001INS,
    },
    {
      path: "CRM01_008INS.xml",
      component: CRM01_008INS,
    },
    {
      path: "CRM01_009RPT.xml",
      component: CRM01_009RPT,
    },
    {
      path: "CRM01_010RPT.xml",
      component: CRM01_010RPT,
    },
    {
      path: "CRM05_003RPT.xml",
      component: CRM05_003RPT,
    },
    {
      path: "CRM05_004RPT.xml",
      component: CRM05_004RPT,
    },
    {
      path: "CRM05_007INS.xml",
      component: CRM05_007INS,
    },
    {
      path: "CRM05_008INS.xml",
      component: CRM05_008INS,
    },
    {
      path: "CRM65_001RPT.xml",
      component: CRM65_001RPT,
    },
    {
      path: "CRM65_002RPT.xml",
      component: CRM65_002RPT,
    },
    {
      path: "CRM65_004RPT.xml",
      component: CRM65_004RPT,
    },
    {
      path: "CRM65_005RPT.xml",
      component: CRM65_005RPT,
    },
    {
      path: "CRM60_004INS.xml",
      component: CRM60_004INS,
    },
    {
      path: "CRM60_006INS.xml",
      component: CRM60_006INS,
    },
    {
      path: "CRM60_008INS.xml",
      component: CRM60_008INS,
    },
    {
      path: "CRM60_009INS.xml",
      component: CRM60_009INS,
    },
    {
      path: "CRM60_007INS.xml",
      component: CRM60_007INS,
    },
    {
      path: "CRM11_006RPT.xml",
      component: CRM11_006RPT,
    },
    {
      path: "CRM11_007RPT.xml",
      component: CRM11_007RPT,
    },
    {
      path: "CRM10_004RPT.xml",
      component: CRM10_004RPT,
    },
    {
      path: "CRM11_013RPT.xml",
      component: CRM11_013RPT,
    },
    {
      path: "CRM40_056RPT.xml",
      component: CRM40_056RPT,
    },
    {
      path: "CRM40_057RPT.xml",
      component: CRM40_057RPT,
    },
    {
      path: "CRM10_001INS.xml",
      component: CRM10_001INS,
    },
    {
      path: "CRM22_001INS.xml",
      component: CRM22_001INS,
    },
    {
      path: "CRM22_002INS.xml",
      component: CRM22_002INS,
    },
    {
      path: "CRM01_013INS.xml",
      component: CRM01_013INS,
    },
    {
      path: "CRM01_050INS.xml",
      component: CRM01_050INS,
    },
    {
      path: "CRM01_012INS.xml",
      component: CRM01_012INS,
    },
    {
      path: "CRM20_003INS.xml",
      component: CRM20_003INS,
    },
    {
      path: "CRM20_011INS.xml",
      component: CRM20_011INS,
    },
    {
      path: "CRM21_004INS.xml",
      component: CRM21_004INS,
    },
    {
      path: "CRM21_002INS.xml",
      component: CRM21_002INS,
    },
    {
      path: "CRM60_010INS.xml",
      component: CRM60_010INS,
    },
    {
      path: "CRM03_019RPT.xml",
      component: CRM03_019RPT,
    },
  ];
}
